import React from 'react'
import PropTypes from 'prop-types'
import {Heading, Text, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {getTextAlignment} from '../../../../../utils/common-utils'

const Title = ({
    title,
    color,
    desktopColor = 'white',
    tag,
    titleSizeMobile,
    titleSizeDesktop,
    titleFontFamily,
    whiteSpace = 'normal',
    addTitleFreeText,
    titlePositionDesktop,
    titlePosition
}) => {
    let textAlignMobile = getTextAlignment(titlePosition)
    let textAlignDesktop = getTextAlignment(titlePositionDesktop)

    const fontWeightMap = {
        caslon: '400',
        cormorant: '500',
        inter: '300'
    }

    const mobileFontSizeMap = {
        normal: '32px',
        small: '24px',
        medium: '36px',
        large: '48px'
    }

    return (
        <Stack
            className="title-stack"
            flexDirection="row"
            gap="10px"
            data-title-position-desktop={titlePositionDesktop}
            data-title-position-mobile={titlePosition}
        >
            {addTitleFreeText && (
                <Text
                    className="title-free-text"
                    fontSize={{
                        base: mobileFontSizeMap[titleSizeMobile],
                        md: mobileFontSizeMap[titleSizeMobile],
                        xl: titleSizeDesktop === 'normal' ? '64px' : '42px'
                    }}
                    letterSpacing={{
                        base: titleSizeMobile === 'normal' ? '0.24px' : '0.16px',
                        md: titleSizeMobile === 'normal' ? '0.24px' : '0.16px',
                        xl: titleSizeDesktop === 'normal' ? '0.32px' : '0.24px'
                    }}
                    fontWeight={fontWeightMap[titleFontFamily || 'caslon']}
                    fontFamily="caslon"
                    lineHeight="normal"
                    textAlign={{base: textAlignMobile, lg: textAlignDesktop}}
                    color={{base: color, lg: desktopColor}}
                    whiteSpace={whiteSpace}
                    fontStyle="italic"
                >
                    <FormattedMessage id="hero.free.text" defaultMessage="free" />
                </Text>
            )}
            <Heading
                className="title-heading"
                as={tag}
                margin="0"
                fontSize={{
                    base: mobileFontSizeMap[titleSizeMobile],
                    md: mobileFontSizeMap[titleSizeMobile],
                    xl: titleSizeDesktop === 'normal' ? '64px' : '42px'
                }}
                letterSpacing={{
                    base: titleSizeMobile === 'normal' ? '0.24px' : '0.16px',
                    md: titleSizeMobile === 'normal' ? '0.24px' : '0.16px',
                    xl: titleSizeDesktop === 'normal' ? '0.32px' : '0.24px'
                }}
                fontWeight={fontWeightMap[titleFontFamily || 'caslon']}
                fontFamily={titleFontFamily || 'caslon'}
                lineHeight="normal"
                textAlign={{base: textAlignMobile, lg: textAlignDesktop}}
                color={{base: color, lg: desktopColor}}
                whiteSpace={whiteSpace}
            >
                {title}
            </Heading>
        </Stack>
    )
}

Title.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    tag: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleSizeMobile: PropTypes.string,
    titleSizeDesktop: PropTypes.string,
    titlePositionDesktop: PropTypes.string,
    titlePosition: PropTypes.string,
    whiteSpace: PropTypes.string,
    addTitleFreeText: PropTypes.bool,
    desktopColor: PropTypes.string,
    textAlignTitleMobile: PropTypes.bool,
    textAlignTitleDesktop: PropTypes.bool
}

export default Title
